export default "__VITE_ASSET__DewBr7c9__"